/* Onglets « notes / composition » de la fiche produit.
   Sorti du <script> inline de la section (non mis en cache, non minifie). */
(() => {
  const init = (root) => {
    if (root.dataset.mmNotesPret === '1') return;
    root.dataset.mmNotesPret = '1';

    const onglets = [...root.querySelectorAll('[data-tab]')];
    const panneaux = [...root.querySelectorAll('[data-panel]')];
    if (!onglets.length) return;

    onglets.forEach((onglet) => {
      onglet.addEventListener('click', () => {
        const nom = onglet.dataset.tab;
        onglets.forEach((t) => {
          const actif = t.dataset.tab === nom;
          t.classList.toggle('is-active', actif);
          t.setAttribute('aria-selected', actif ? 'true' : 'false');
        });
        panneaux.forEach((p) => {
          const actif = p.dataset.panel === nom;
          p.classList.toggle('is-active', actif);
          p.toggleAttribute('hidden', !actif);
        });
      });
    });
  };

  const boot = (scope) => scope.querySelectorAll('[data-mm-notes]').forEach(init);
  boot(document);
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
